import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-confirmation-reason-modal',
  templateUrl: './confirmation-reason-modal.component.html',
  styleUrls: ['./confirmation-reason-modal.component.scss'],
  standalone: false,
})
export class ConfirmationReasonModalComponent {
  reasonControl = new FormControl('', [Validators.required]);

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { note: string; customClose: (reason: string) => void | null },
    public dialogRef: MatDialogRef<ConfirmationReasonModalComponent>
  ) {}

  proceed() {
    const { value, invalid } = this.reasonControl;

    if (invalid) {
      return;
    }

    if (this.data?.customClose) {
      this.data.customClose(value);
    } else {
      this.dialogRef.close({
        reason: value,
      });
    }
  }
}
